// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"estimatedCommissionModal_tableWrapper__3UwC5"};